import React, { useLayoutEffect } from 'react'

import { PAYMENTS_CONTAINER_PREFIX } from 'features/klarna/constants'
import useKlarnaPayments from 'features/klarna/hooks/useKlarnaPayments'

const KlarnaPayment: React.FC<any> = ({ shouldLoad, paymentMethodCategory, newSessionDetails }) => {
  const { load } = useKlarnaPayments()

  useLayoutEffect(() => {
    if (shouldLoad) {
      load({
        paymentMethodCategory,
        newSessionDetails,
      })
    }
  }, [shouldLoad, paymentMethodCategory, newSessionDetails])

  return (
    <div
      id={`${PAYMENTS_CONTAINER_PREFIX}${paymentMethodCategory}`}
      data-testid={`${PAYMENTS_CONTAINER_PREFIX}${paymentMethodCategory}`}
    />
  )
}

export default KlarnaPayment
